/**
 * Where the two dots sit on the climb.
 *
 * Lifted out of BeatTheYeti so the small tiles on All Department Metrics place
 * their dots by exactly the same rule — one definition, or the same metric
 * reads as two different races on two cards of the same board.
 */

const clamp = (v, a, b) => Math.max(a, Math.min(b, v));

/**
 * Scale a MONTHLY target down to the window being shown, mirroring the Yeti's
 * own proration (buildYetiScoresForKpis): a day is target ÷ business days in
 * the month; a week is five of those. Rates, averages, and whole-month /
 * anchor metrics keep their full target — they are period-independent.
 */
export const targetForBucket = (kpi, bucket, totalDays) => {
  const tgt = Number(kpi?.target) || 0;
  if (!tgt || bucket === "month" || bucket === "lastMonth") return tgt;
  if (kpi.wholeMonth || kpi.metricType === "anchor" || kpi.kind === "%" || kpi.calc === "avg") return tgt;
  const days = totalDays > 0 ? totalDays : 21;
  const units = bucket === "week" ? Math.min(5, days) : 1;
  return (tgt / days) * units;
};

/**
 * Each side's standing against a shared scale, so the dot sitting higher up
 * the mountain is the one that is ahead. The target in the scale is prorated
 * to the window shown, or a single day's numbers would be squashed to the
 * mountain's foot by the full monthly goal.
 *
 * @returns {{ player: number, yeti: number }} fractions along the climb line
 */
export const climbFracs = ({ kpi, playerAmt, yetiAmt, bucket, totalDays }) => {
  const p = Number(playerAmt) || 0;
  const y = Number(yetiAmt) || 0;
  const periodTarget = targetForBucket(kpi, bucket, totalDays);
  const max = Math.max(p, y, periodTarget, 1);
  return {
    /* Never pinned to either end: a dot at 0 or 1 sits off the visible line
       and reads as "no data" rather than "far behind". */
    player: clamp(p / max, 0.06, 0.94),
    yeti: clamp(y / max, 0.06, 0.94),
  };
};
